import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="android"
export default class extends Controller {
  connect() {
    if (typeof AndroidPlayer === 'undefined') return;

    this.updateState();

    this.interval = setInterval(this.updateState.bind(this), 2000);

    this.checkAndroidSettings();

    // Voeg dit toe aan je website (bijv. in je main.js)
    window.onAppStatusChanged = (status) => {
      //document.querySelector('#debug').textContent = 'App status changed: ' + status;

      if (status == 'active') {
        document.querySelector('#debug').textContent = 'Uit slaap';
        setTimeout(() => window.location.reload(), 1000);
      }
    };
  }

  updateState() {
    const statusJson = AndroidPlayer.getSystemStatus();
    const status = JSON.parse(statusJson);

    let state = (status.canDrawOverlays && !status.isBatteryOptimized);
    this.element.classList.toggle('android--active', !state);

    if (state) {
      clearInterval(this.interval);
      return;
    }
  }

  checkAndroidSettings() {
    // Controleer eerst of we in de Android App draaien
    // Haal de JSON status op uit de native app
    const statusJson = AndroidPlayer.getSystemStatus();
    const status = JSON.parse(statusJson);

    document.querySelector('#debug').textContent = JSON.stringify(status);

    let overlayButton = document.createElement('button');
    overlayButton.textContent = 'Open Overlay Settings';
    overlayButton.onclick = () => {
      AndroidPlayer.openOverlaySettings();
    };
    this.element.appendChild(overlayButton);

    // focus on element
    setTimeout(() => overlayButton.focus(), 1000);

    let batteryButton = document.createElement('button');
    batteryButton.textContent = 'Open Battery Settings';
    batteryButton.onclick = () => {
      document.querySelector('#debug').textContent = 'Opening Battery Settings...';
      AndroidPlayer.openBatterySettings();
    };
    this.element.appendChild(batteryButton);
  }
}
